import { reactive } from "vue";
import { sleep } from "@/middleware/helper-functions.js";

const state = reactive({ loadingCount: 0, mounted: false, sistemaBloqueado: false, sistemaBloqueadoAdmin: false });

const ensureIsMounted = async () => {
  while (!state.mounted) {
    await sleep(100);
  }
};

export default { state, ensureIsMounted };
